import { render, staticRenderFns } from "./ObjectDetail.vue?vue&type=template&id=3c8cbd9e&"
import script from "./ObjectDetail.vue?vue&type=script&lang=js&"
export * from "./ObjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./ObjectDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports